module.exports = __webpack_public_path__ + "static/media/home-charger-screenshot.c349cdcb.png";